import { render, staticRenderFns } from "./NewCourse.vue?vue&type=template&id=11455d9d&"
import script from "./NewCourse.vue?vue&type=script&lang=js&"
export * from "./NewCourse.vue?vue&type=script&lang=js&"
import style0 from "./NewCourse.vue?vue&type=style&index=0&id=11455d9d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports